export default __webpack_public_path__ + "static/media/13-1.86ea643e.png";